<template>
  <div>
    <el-form
      :model="selectData"
      ref="selectForm"
      :rules="rules"
      class="editForm"
      label-width="100px"
      label-suffix="："
    >
      <el-form-item label="选择更新列" prop="payGroup">
        <el-select v-model="form.column" multiple filterable="true" @change="changeItem" placeholder="请选择更新列">
          <el-option
            v-for="item in columnData"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>

  import Vue from 'vue'

  export default {
    name: "selectPerson",
    props:{
      selectData: {
        type: Array,
        default: () => (
          []
        )
      },

    },
    created(){
    },
    components:{},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'name'
        },

      };
    },
    methods:{


    }
  };
</script>

<style scoped>
  .flex{
    display: flex;
  }
  .flex>div{
    height: 800px;
  }
  .flex>div:nth-of-type(1){
    width: 250px;
    border-right: 1px solid #ccc;
    padding-right: 20px;
    margin-right:20px;
    overflow: auto;
  }
  .flex>div:nth-of-type(2){
    width: calc(100% - 255px);
  }
</style>
